// removed by extract-text-webpack-plugin
module.exports = {"block":"_1kq2NDaX9ClrQd7SaPdeP_","bg":"jGjg6eLtkC7I2YgGFZqfJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BannersListBlock/BannersListBlock.module.scss
// module id = 734
// module chunks = 0